(function (w, d) {
	function createScript(src, id) {
		const element = d.createElement('script');
		element.async = true;
		if (id) {
			element.id = id;
		}
		element.src = src;
		element.crossorigin = 'anonymous';
		const script = d.getElementsByTagName('script')[0];
		script.parentNode.insertBefore(element, script);
	}

	const zendeskKey = '19ea6f5d-88c2-45ee-9402-7413da63d5ce';
	const zendeskArg = [
		'https://static.zdassets.com/ekr/snippet.js?key=' + zendeskKey,
		'ze-snippet',
	];
	const recaptchaKey = '?onload=onloadCallback&render=explicit';
	const recaptchaArg = ['https://www.google.com/recaptcha/api.js' + recaptchaKey];
	const hasRecaptcha = d.querySelector('.js-g-recaptcha');

	setTimeout(() => {
		createScript.apply(null, zendeskArg);
		if (hasRecaptcha) createScript.apply(null, recaptchaArg);
	}, 5000);
})(window, document);
